module.exports = __webpack_public_path__ + "static/media/vase2.b2b5f85f.jpg";